export const colorToken = {
    color1: "#4dc7f4",
    color2: "#093261",
    color3: "#100700",
    white: "white",
    black: "rgb(0,0,0)",
};

export const APIS = {
    public: 'https://k7m7c8qigb.execute-api.us-east-1.amazonaws.com/prod/api',
    private: 'https://k7m7c8qigb.execute-api.us-east-1.amazonaws.com/prod/api/private-endpoint'
}

export const settingsTheme = {
    baseUnit: "4",
};

export const menuList = [
    {
        link: "#comoparticipar",
        title: "Como Participar",
        externalLink: false,
    },
    {
        link: "#premios",
        title: "Prêmios",
        externalLink: false,
    },
    {
        link: "#ganhadores",
        title: "Ganhadores",
        externalLink: false,
    }
];